import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { LoadingService } from '../../services/loading.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading, .app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner]
})
export class LoadingComponent implements AfterViewInit, OnDestroy {
  private alive = true;

  constructor(
    private readonly loadingService: LoadingService,
    private readonly elmRef: ElementRef,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.elmRef.nativeElement.style.display = 'none';
    this.loadingService.loading$.pipe(takeWhile(() => this.alive)).subscribe((loading: boolean) => {
      this.elmRef.nativeElement.style.display = loading === false ? 'none' : 'block';
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
